import { testimonials } from '../../../mocks/products';

export default function ReviewsSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-deep-black to-forest-green/20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          {/* Rating Badge */}
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-copper/10 border border-copper/30 rounded-full mb-6">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-copper text-lg"></i>
              ))}
            </div>
            <span className="text-copper font-semibold text-lg">5.0</span>
          </div>

          <h2 className="font-serif text-4xl lg:text-5xl text-white mb-4">
            What Our Customers Say
          </h2>
          <p className="text-gray-400 text-lg">
            Trusted by hundreds of satisfied customers across Central Florida
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="bg-forest-green rounded-2xl p-8 hover:shadow-xl hover:shadow-copper/10 transition-all duration-300 hover:-translate-y-1"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Stars */}
              <div className="flex items-center gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-copper text-lg"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-white font-serif text-xl italic leading-relaxed mb-8">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-white font-semibold">{testimonial.name}</p>
                  <p className="text-copper text-sm">Verified Customer</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
